import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export var push = normalize.push(function (options) {
  var url = options.url,
    _options$isHash = options.isHash,
    isHash = _options$isHash === void 0 ? false : _options$isHash,
    _options$refresh = options.refresh,
    refresh = _options$refresh === void 0 ? true : _options$refresh,
    success = options.success,
    fail = options.fail,
    complete = options.complete;
  setTimeout(function () {
    try {
      if (isHash) {
        location.hash = "#" + url;
      } else if (refresh) {
        location.href = url;
      } else {
        var state = {
          page_id: 1
        };
        var title = '';
        history.pushState(state, title, url);
      }
      success && success();
      complete && complete();
    } catch (e) {
      fail && fail(e);
      complete && complete(e);
    }
  });
}, CONTAINER_NAME.WEB);
export default push;